
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"46","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Vector Smart Object copy 8","width":"46","height":"46","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAACxUlEQVRoge2YPWhTURiGH9MfaCIVwZ9KhC4FK1Ho1EAcitCh/qwdxLGbP5MOHQQFwaV0rdDBOYvoUBQsWnAtAUVEhYLSSW1rKqipFIyc8AaOpXh/zrn3UsgLlwSS837P/e6553zf2Uc0jQAXgDPASaAI9MhhA/gI1IDnwFPgR0R/r+oFpoC3QNO6GsA74JWuLzt+N9DzwFAW0OPAewtmCbgKDAO7Pa1+YAKYA9Y1ZhuYBQppAHcBMxbwQ+BURI8+4DqwJg+TgFJCvC3lgUcK9hk45+h3EKjK7zsw5onzH3VZ0GbeHvPofVO+P4FRj74tzVjQB3yb6/1o6kUe8GU6bk0Pn5neqXZynvkw67VWD9c5HSSz7i8r1qSr2ZS1eqShsrXS5FzitTeXqEueixYU83xcjxFrc0lTE4pbjRvzlgyupAzeDXwD6nGnyxOBD/tnC9RjxT4ddWBOVd4W8CF9bl7rM3LScipNP+nO09aq4hXjgJt19XcG0Eab+uyPOtBpDfWgPlk04oBv+KwbIuqw/r4ZdWBO7dbROI/Lg07IYiUOeE3fKxmAV6xqNLImNXguZehBxa2F+O+u2q/Gdt16WdLQbYFPu8Sal8m1lKAL6kW3XBeGIXXja+oRk9Y9n9Nz1rVaC6mykmSKqyM+DAtWF3QjIejj2uZNjEs+jUs6QkiizDXQb+R937N3S2M6Qmiqse0JMSZIZSvT7aYlnwT8qHUWuKzAcVTQi7htZXpJ318kBT+gI4R2lhbUbnWHGDuodbp9/Fa35nRe0E7wYY6Zzc5616orDMRLNQGrKpDMxnVIDUHF6mhMufwAuAN8tTzzSsRZPYGLwK84NxCknLrxqsCb/7n+aBufDthcnDIf9WAf3URJ2S2qqmwo8ysqmOohvVLLfBLyMuc78DHUgc9KHfis1IHPSh34rGTDL+4lcCMDvwhc/guef9XbPUVlhwAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    